//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
let d=[[],[[[],"CollectSharedExpression",{R_:{numExpresssion:''}},0,0],[["selectedCompTag"],"SetSelectedComponent",{},1,0],[[],"GetSelectedComponent",{R_:{selectedCompTag:"NXObject"}},0,0],[["name","value"],"SetExpressionValue",{},2,0],[["expressionValues"],"SetExpressionsArray",{},1,0],[["numValues"],"GetExpressionsArray",{R_:{expressions:"Expression[]"}},0,0],[["expression"],"GetExpressionTitle",{R_:{expTitle:''}},1,0],[["expressionTitle","numValues"],"CollectExpressionValues",{R_:{exp:""}},1,0],[["toolTipMessage"],"SetToolTipMessage",{},1,0],[[],"GetToolTipMessage",{R_:{toolTipMessage:''}},0,0]],[]];
SPLM.LineDesigner.ModifyConnectedSystemBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.ModifyConnectedSystemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;